// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"ulQEbrRBwc4Dg1-F7hVN7Q=="};